import currencyFormatter from 'currency-formatter';
import MoneyIcon from 'material-ui-icons/MonetizationOn';
import MoneyIconOff from 'material-ui-icons/MoneyOff';
import Clock from 'material-ui-icons/Timer';
import Paper from 'material-ui/Paper';
import { withStyles } from 'material-ui/styles';
import Table, { TableBody, TableCell, TableFooter, TablePagination, TableRow } from 'material-ui/Table';
import Tooltip from 'material-ui/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from 'react-i18next';
import { tableSortFunction } from '../../Utils/tableSortFunction';
import InvoicesTableHeader from './InvoicesTableHeader';
import InvoicesTableMenu from './InvoicesTableMenu';
import InvoicesTableToolbar from './InvoicesTableToolbar';
import { exportToXLS } from '../../Utils/exportToXLS';
import { exportToPDF } from '../../Utils/exportToPDF';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 800,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    invoiceLocator: {
        color: 'var(--primary-color)'
    }
});

function getIconForEstado(estado, t) {
    estado = estado || '';
    let icon = <p></p>;
    let title = estado;
    switch (estado.toUpperCase()) {
    case 'PAGADA':
        title = t('INVOICES.CHARGED');
        icon = <MoneyIcon />;
        break;
    case 'PARCIALMENTEPAGADA':
        title = t('INVOICES.PARTLY_PAYED_SINGLE');
        icon = <MoneyIconOff />;
        break;
    case 'PENDIENTE':
        title = t('INVOICES.PENDING_SINGLE');
        icon = <Clock />;
        break;
    }
    return <Tooltip title={title}>{icon}</Tooltip>;
}

class InvoicesTable extends React.Component {
    /**
     * Sort Table data.
     * @param {type} event
     * @param {String} property column id
     */
    handleRequestSort = (event, property, columnsDataArray) => {
        const colDef = columnsDataArray.find(col => col.id === property);
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const data = tableSortFunction(this.props.data, order, colDef);
        this.setState({ data, order, orderBy });
    };
    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({ selected: this.state.data.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };
    handleClick = (event, id) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({ selected: newSelected });
    };
    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;

    exportList = (format) => {

        const { t } = this.props;
        let invoices = JSON.parse(localStorage.getItem('facturas'));
        if (invoices) {
            const headers = [
                t('INVOICES.INVOICE'),
                t('INVOICES.OLYMPIA_LOCATOR'),
                t('INVOICES.INVOICE_DATE'),
                t('INVOICES.AMOUNT'),
                t('INVOICES.STATE')
            ];


            const invoicesToPrint = invoices.map(invoice => {
                return {
                    'Localizador': invoice.Localizador,
                    'Expediente': invoice.Expediente,
                    'FechaAlta': invoice.FechaAlta,
                    'Importe': format.toUpperCase() === 'PDF' ?
                        invoice.Importe + ' EUR' :
                        parseFloat(invoice.Importe),
                    'Estado': invoice.Estado
                };
            });

            switch (format.toUpperCase()) {
            case 'PDF':
                exportToPDF(invoicesToPrint, headers, 'Invoices');
                break;
            case 'XLS':
                exportToXLS(invoicesToPrint, headers, 'Invoices', 'Invoices');
                break;
            }
        }

        return;
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            order: 'asc',
            orderBy: 'id',
            selected: [],
            data: [],
            page: 0,
            rowsPerPage: 10,
            anchorEl: null
        };
    }

    render() {
        const { classes, t } = this.props;
        const { order, orderBy, selected, rowsPerPage, page } = this.state;

        let length = 0 || this.props.data.length;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, length - page * rowsPerPage);

        return (
            <Paper className={classes.root}>
                <InvoicesTableToolbar
                    numSelected={selected.length}
                    actionHandler={this.exportList}
                />
                <div className={classes.tableWrapper}>
                    <Table className={classes.table}>
                        <InvoicesTableHeader
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={this.handleSelectAllClick}
                            onRequestSort={this.handleRequestSort}
                            rowCount={this.props.data.length}
                            showActions={true}
                            t={t}
                        />
                        <TableBody>
                            {this.props.data && this.props.data.length ?
                                this.props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                    const isSelected = this.isSelected(n.id);
                                    return (
                                        <TableRow
                                            hover
                                            /*onClick={event => this.handleClick(event, n.id)}*/
                                            aria-checked={isSelected}
                                            tabIndex={-1}
                                            key={n.id}
                                            selected={isSelected}>
                                            <TableCell padding={'none'} style={{ paddingLeft: '10px' }}>
                                                <a className={classes.invoiceLocator} href={'#/invoices'}
                                                    onClick={(event) => {
                                                        if (this.props.actionhandler) {
                                                            this.props.actionhandler(n, 'VIEW');
                                                        }
                                                    }}
                                                ><b>{n.Localizador}</b></a>
                                            </TableCell>
                                            <TableCell padding={'none'}>
                                                {n.Expediente}
                                            </TableCell>
                                            <TableCell padding={'none'}>{n.FechaAlta}</TableCell>
                                            <TableCell padding={'none'}>
                                                <strong>{currencyFormatter.format(n.Importe, { code: 'EUR' })}</strong>
                                            </TableCell>
                                            <TableCell padding={'none'}>
                                                {this.props.allowedActions ?
                                                    <InvoicesTableMenu
                                                        options={this.props.allowedActions}
                                                        reservation={n}
                                                        actionhandler={this.props.actionhandler}
                                                        labels={this.props.menuactionslabels} />
                                                    : ''
                                                }
                                            </TableCell>
                                            <TableCell padding={'none'}>
                                                <div className={'InvoiceRender' + n.Estado}>
                                                    {getIconForEstado(n.Estado, t)}
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                                :
                                emptyRows > 0 && (
                                    <TableRow style={{ height: 49 * emptyRows }}>
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    count={this.props.data.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    backIconButtonProps={{
                                        'aria-label': 'Previous Page',
                                    }}
                                    nextIconButtonProps={{
                                        'aria-label': 'Next Page',
                                    }}
                                    labelRowsPerPage={'Mostrando'}
                                    labelDisplayedRows={({ from, to, count }) => `${from} - ${to} de ${count}`}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
            </Paper>
        );
    }
}

InvoicesTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default translate('translations')(withStyles(styles)(InvoicesTable));


// WEBPACK FOOTER //
// ./src/components/Invoices/Table/InvoicesTable.js